import { render } from "./AgentAvgEarningsTwoChart.vue?vue&type=template&id=0f7d45d0&ts=true"
import script from "./AgentAvgEarningsTwoChart.vue?vue&type=script&lang=ts"
export * from "./AgentAvgEarningsTwoChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__